import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import {
  Box,
  IconButton,
  Button,
  Typography,
  Modal,
  Tabs,
  Tab,
  TextField,
} from "@mui/material";
import Api from "./Api";
import { BASE_API_URL } from "./const";
import axios from "axios";

const Header = () => {
  const navigate = useNavigate();
  const userString = localStorage.getItem("mbase.login");
  const [open, setOpen] = useState(false); // Состояние модального окна
  const [activeTab, setActiveTab] = useState(0); // Состояние активной закладки
  const [data, setData] = useState(""); // Состояние для ID фильма
  const [isLoading, setIsLoading] = useState(false); // Состояние для загрузки

  const handleAddFilm = async () => {
    if (!data.trim()) {
      alert("ID фильма не может быть пустым.");
      return;
    }

    try {
      setIsLoading(true); // Начало загрузки

      const response = await Api.post(`${BASE_API_URL}/api/parse/kinopoisk`,
        { kinopoisk: data }
      );
// Обработка успешного ответа
      const { id } = response.data.data; // Извлечение id из ответа
      if (id) {
        const confirmed = alert(
          `Фильм успешно добавлен! Переход на страницу фильма.`
        );
        // Перенаправление на новую страницу с использованием id
        if (confirmed !== null) {
          window.location.href = `${BASE_API_URL}/api/parse/filmdata?id=${id}`;
        }
      }
    } catch (error) {
      alert(error.response?.data?.message || "Не удалось добавить фильм.");
    } finally {
      setIsLoading(false); // Конец загрузки
    }
  };

  const handleLogout = async () => {
    try {
      await Api.post(`${BASE_API_URL}/api/user/logout`, {});
      localStorage.removeItem("mbase.login");
      localStorage.removeItem("mbase.password");
      localStorage.removeItem("mbase.token");
      navigate("/auth");
    } catch (error) {
      console.error("Ошибка при выходе:", error);
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <header
        style={{
          marginBottom: 10,
          padding: "5px",
          backgroundColor: "#1976d2",
          color: "#fff",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* Левая часть с иконкой "Домой" */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Link to="/" style={{ textDecoration: "none" }}>
              <IconButton>
                <HomeIcon sx={{ color: "#E0F7FA", fontSize: "25px" }} />
              </IconButton>
            </Link>
            <a
              href="/met"
              style={{
                textDecoration: "none",
                color: "#E0F7FA",
                fontSize: "12px",
                fontWeight: "bold",
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              MET
            </a>
          </Box>

          {/* Правая часть с именем пользователя и кнопкой "Выход" */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <span style={{ fontSize: "16px" }}>{userString}</span>
            <Button
              onClick={handleLogout}
              variant="text"
              size="small"
              sx={{
                color: "#E0F7FA",
                padding: "2px 8px",
                minWidth: "auto",
                fontSize: "10px",
                textTransform: "none",
              }}
            >
              Выход
            </Button>
          </Box>
        </Box>

        {/* Кнопка "Добавить фильм" на следующей строке */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: 1,
          }}
        >
          <Button
            onClick={handleOpen}
            variant="contained"
            size="small"
            sx={{
              backgroundColor: "#4caf50",
              color: "#fff",
              fontSize: "12px",
              textTransform: "none",
            }}
          >
            Добавить фильм
          </Button>
        </Box>
      </header>

      <Box>
        <Typography variant="h1" align="center" gutterBottom>
          MBase
        </Typography>
      </Box>

      {/* Модальное окно */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            bgcolor: "background.paper",
            borderRadius: "10px",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" align="center" sx={{ mb: 2 }}>
            Добавить фильм
          </Typography>

          {/* Закладки */}
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            sx={{ borderBottom: 1, borderColor: "divider" }}
          >
            <Tab label="Добавление файла" />
            <Tab label="Добавление с Кинопоиск" />
          </Tabs>

          <Box sx={{ mt: 2 }}>
            {activeTab === 0 && (
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr 3fr 1fr", // Три столбца: текст, поле ввода, кнопка
                  gap: 2,
                  alignItems: "center", // Центрирование по вертикали
                }}
              >
                {/* Поля с текстовыми описаниями и ввода */}
                <Box sx={{ gridColumn: "1 / 3", display: "grid", gap: 1 }}>
                  {/* Поле "Русское название" */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center", // Центрирование текста и поля ввода
                    }}
                  >
                    <Typography
                      sx={{ width: "30%", color: "orange", fontWeight: "bold" }}
                    >
                      Русское название
                    </Typography>
                    <TextField fullWidth size="small" />
                  </Box>

                  {/* Поле "Оригинальное название" */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{ width: "30%", color: "orange", fontWeight: "bold" }}
                    >
                      Оригинальное название
                    </Typography>
                    <TextField fullWidth size="small" />
                  </Box>

                  {/* Поле "Год выхода" */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{ width: "30%", color: "orange", fontWeight: "bold" }}
                    >
                      Год выхода
                    </Typography>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      SelectProps={{ native: true }}
                    >
                      <option value="">--- Все года ---</option>
                    </TextField>
                  </Box>

                  {/* Поле "Страна" */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{ width: "30%", color: "orange", fontWeight: "bold" }}
                    >
                      Страна
                    </Typography>
                    <TextField fullWidth size="small" />
                  </Box>

                  {/* Поле "Жанр" */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{ width: "30%", color: "orange", fontWeight: "bold" }}
                    >
                      Жанр
                    </Typography>
                    <TextField fullWidth size="small" />
                  </Box>

                  {/* Поле "Описание" */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{ width: "30%", color: "orange", fontWeight: "bold" }}
                    >
                      Описание
                    </Typography>
                    <TextField fullWidth size="small" multiline rows={4} />
                  </Box>

                  {/* Поле "Постер" */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{ width: "30%", color: "orange", fontWeight: "bold" }}
                    >
                      Постер
                    </Typography>
                    <Button variant="contained" component="label">
                      Выберите файл
                      <input type="file" hidden />
                    </Button>
                  </Box>
                </Box>

                {/* Кнопка "Добавить" */}
                <Box
                  sx={{
                    gridColumn: "3 / 4",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    variant="contained"
                    color="warning"
                    sx={{
                      alignSelf: "flex-start",
                      height: "40px",
                      minWidth: "80px",
                    }}
                  >
                    Добавить
                  </Button>
                </Box>
              </Box>
            )}
            {activeTab === 1 && (
              <Box>
                {/* Разметка для "Добавление с Кинопоиск" */}
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Введите ID фильма с Кинопоиск для автоматического добавления.
                </Typography>
                <TextField
                  label="ID фильма с Кинопоиск"
                  fullWidth
                  margin="normal"
                  size="small"
                  value={data} // Значение из состояния
                  onChange={(e) => setData(e.target.value)} // Обновление состояния
                />
                <Button
                  variant="contained"
                  sx={{ mt: 2, display: "block" }}
                  onClick={handleAddFilm}
                  disabled={!data.trim() || isLoading} // Кнопка неактивна, если текст пуст или идет загрузка
                >
                  {isLoading ? "Загрузка..." : "Добавить"}
                </Button>
              </Box>
            )}
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default Header;
